export default __webpack_public_path__ + "static/media/icon-10.5a5164f9.png";